export default __webpack_public_path__ + "static/media/magazzini-dark.e0fe80af.svg";